import React from 'react';
import type { RowType } from '@atlaskit/dynamic-table/types';
import { fg } from '@atlassian/jira-feature-gating';
import type { Plan } from '@atlassian/jira-plans-main/src/common/types';
import { TITLE, CREATOR, STATUS_CHANGED_TIMESTAMP, LEAD } from '../../../common/constants';
import type { PlansList, RefetchPlans, Status } from '../../../common/types';
import CreatorCell from './cells/creator-cell/index.tsx';
import DateCell from './cells/date-cell/index.tsx';
import LeadCell from './cells/lead-cell/index.tsx';
import PlanCell from './cells/plan-cell/index.tsx';
import { getColumnsByStatus } from './utils';

export default function getTableRows(
	data: PlansList,
	status: Status,
	refetchPlans: RefetchPlans,
): RowType[] {
	if (!data || !data.total) {
		return [];
	}

	const visibleRows: RowType[] = data.values.map(
		(plan: Plan): RowType => ({
			cells: [
				{
					// @ts-expect-error - Property 'onClick' is missing in type '{ plan: Plan; status: Status; }' but required in type 'Props'.
					content: <PlanCell plan={plan} status={status} />,
					//  key is added to stop table from internally sorting data
					key: TITLE,
				},
				fg('allow_users_to_change_plan_lead')
					? {
							content: <LeadCell plan={plan} />,
							key: LEAD,
						}
					: {
							content: <CreatorCell plan={plan} />,
							key: CREATOR,
						},
				{
					content: <DateCell plan={plan} />,
					key: STATUS_CHANGED_TIMESTAMP,
				},
				...getColumnsByStatus(status, plan, refetchPlans),
			],
		}),
	);

	return visibleRows;
}
